import { linkToClassAssignmentsPage } from "../links";

export function linkToAssignmentPage(
  classId?: string,
  assignmentId: string = ":assignmentId"
) {
  return `${linkToClassAssignmentsPage(classId)}/assignment/${assignmentId}`;
}
